
import React, { useState, useEffect } from "react";
import app from "../../../firebaseConfig";
import { getDatabase, ref, get } from "firebase/database";
import { motion } from "framer-motion"; // Importamos framer-motion
import { useNavigate,useSearchParams } from "react-router-dom"; // Importamos useNavigate

import Lottie from "react-lottie-player";
import rayoazul from './assets/lottie/rayoazul.json';
import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

// Función para mezclar un array aleatoriamente (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };

export default function AwooEntrada() {
    
  const navigate = useNavigate(); // Hook para navegar entre páginas
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito

  const [searchParams] = useSearchParams();
  const mesa = searchParams.get("mesa"); // Obtiene el número de la mesa

  // Arreglo de animaciones disponibles
  const animacionesDisponibles = [
    lineasblancasvolando,
    efectoparticulas,
    fuegoamarillo,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    neutron,
    ondacircular,
    ondacircular,
    ondacircular,
    fuegoamarillo,
  ];


// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};

     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);


  ////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);

////////////////////////


useEffect(() => {
  const db = getDatabase(app);
  const categoriasRef = ref(db, "nature/Awoo/Categorias");

  // Obtener categorías
  get(categoriasRef).then((snapshot) => {
    if (snapshot.exists()) {
      const categoriasData = snapshot.val();
      const categoriasArray = Object.keys(categoriasData);

      // Obtener imágenes y verificar visibilidad
      Promise.all(
        categoriasArray.map(async (categoria) => {
          const visibleSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
          const visible = visibleSnapshot.exists() ? visibleSnapshot.val().toLowerCase() : "no"; // Si no existe, por defecto "no"

          if (visible === "si") {
            const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
            const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";
            return { nombre: categoria, img: imgUrl };
          }
          return null; // Retorna null si no debe mostrarse
        })
      ).then((data) => {
        const categoriasFiltradas = data.filter((item) => item !== null); // Elimina los null
        setCategorias(shuffleArray(categoriasFiltradas)); // Mezcla y actualiza el estado
      });
    }
  });
}, []);


  const handleCategoriaClick = (categoria) => {
    navigate("/awooproductosusuario", { state: { categoria, mesa  } }); // Navegar con estado
  };

  
  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#000", color: "white", textAlign: "center", padding: "10px" }}>
            



  {/* Logo o nombre del negocio */}
 {/* --- Logo Awoo --- */}
<div
  style={{
    marginLeft: "15px",
    position: "relative",
    width: "350px",
    flexShrink: 0, // Evita que las tarjetas se reduzcan
  }}
>

<div 
       style={{
        display: "flex",
    justifyContent: "center", // Centra horizontalmente
    alignItems: "center", // Centra verticalmente si tiene altura definida
    whiteSpace: "nowrap",
    width: "100%", // Asegura que ocupe todo el ancho
    padding: "5px 0", // Opcional: agrega espacio vertica
      }}>
        
        <div
            style={{
              position: "relative",
              width: "150px",
              display: "inline-block",
              marginRight: "10px"
            }}
            //onClick={() => navigate("/vistacontenedor", { state: { ...event } })}
            //onClick={() => handleClick(event)}

          >
            <div
              style={{
                position: "relative",
                overflow: "visible"
              }}
            >
              <img
                src={ "images/awoo.png"}
                alt={`Evento`}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "50%"
                }}
                
              />


              
 {/* Animación de fondo */}
 <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        justifyContent: "center",
        width: '300px',
        height: '300px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />

              
            
            </div>
            <div
              style={{
                textAlign: "center",
                fontSize: "14px",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              {""}
            </div>
          </div>
      </div>
</div>

   {/* Boton Carrito de Compras */}
{/* Botón Carrito de Compras (se oculta si carritoCantidad es 0) */}
{carritoCantidad > 0 && (
  <div
    style={{
      marginTop: "-130px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "15px",
      position: "relative",
      marginRight: "65px",
      width: "100%",
      flexShrink: 0,
    }}
  >
    {/* --- Icono Carrito Compras --- */}
    <div
      onClick={irAlCarrito}
      style={{
        marginLeft: "15px",
        position: "relative",
        width: "60px",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: "relative",
          borderRadius: "15px",
          overflow: "visible",
        }}
      >
        {/* Círculo del carrito */}
        <div
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "5px solid #2ae5e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: "url('images/carrito.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Etiqueta inferior con cantidad */}
        <div
          style={{
            position: "absolute",
            bottom: "-10px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fa0a02",
            color: "white",
            padding: "4px 8px",
            borderRadius: "10px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          {carritoCantidad}
        </div>
      </div>
    </div>
  </div>
)}




<p style={{ marginTop:"80px", fontSize: "18px", maxWidth: "300px", color: "white"}}>
  <span style={{ color: "#f034d4" }}>Descubre</span> una experiencia{" "}
  <span style={{ color: "#4df9fc" }}>única</span> en sabores.
</p>
    
            {/* Botones de opciones */}
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#000", color: "white", textAlign: "center", padding: "10px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {categorias.map((categoria, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            style={{ marginLeft: "15px", position: "relative", width: "350px", flexShrink: 0 }}
            onClick={() => handleCategoriaClick(categoria.nombre)} // Agregamos onClick
          >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", overflowX: "auto", whiteSpace: "nowrap", width: "100%", padding: "10px 0", cursor: "pointer" }}>
              <div style={{ position: "relative", width: "250px", display: "inline-block", marginRight: "10px" }}>
                <div style={{ padding: "4px", backgroundColor: "#4df9fc", borderRadius: "6%", display: "inline-block", width: "100%" }}>
                  <img src={categoria.img} alt={categoria.nombre} style={{ width: "100%", height: "65px", objectFit: "cover", borderRadius: "5%", display: "block" }} />
                </div>
                <div style={{ position: "absolute", bottom: "-10px", left: "50%", transform: "translateX(-50%)", width: "50%", backgroundColor: "#3cca07", color: "white", padding: "8px", borderRadius: "10px", textAlign: "center", fontWeight: "bold", fontSize: "14px" }}>
                  {categoria.nombre}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>


        </div>
    );
}

const botonEstilo = {
    width: "100%",
    padding: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    background: "#e27f0e",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
};
